export enum ButtonSize {
  Default = 'defualt',
  Small = 'small',
  Large = 'large',
}
